// extracted by mini-css-extract-plugin
export default {"search-page":"style_search-page__wVJQZ"};